<div class="d-flex justify-content-center align-items-center oops-background" style="height: 100vh;">
  <div>
    <h1 class="text-center" id="oops-text">Oops!</h1>
    <h2 class="text-center">Quasta pagina non è stata trovata...</h2>
    <div class="d-flex justify-content-center align-items-center mt-5">
      <!-- <button class="btn btn-primary text-white fw-bold mx-auto px-5 py-1" (click)="backHome()">Home</button> -->
      <button mat-flat-button color="primary" class="px-5 py-1 fw-bold" (click)="backHome()">HOME</button>
    </div>
  </div>
</div>